<template>
    <v-container class="view-wrapper" fluid>
        <v-row v-if="announcements.length" class="custom-background">
            <v-col cols="12" class="d-flex align-start justify-start">
                <marquee class="marquee mt-1" width="100%" scrollamount="5">
                    <span v-for="announcement in announcements" :key="announcement.id">
                        {{ announcement.text }}
                    </span>
                </marquee>
            </v-col>
        </v-row>
        <v-row class="px-2 py-2 background">
            <span class="logo-container">
                <v-img
                    width="90px"
                    height="auto"
                    :src="require('@/assets/mobile-logo.png')"
                />
            </span>
            <div class="station-wrapper">
                <span>
                    <v-img
                        width="50"
                        height="auto"
                        class="train-icon"
                        :src="require('@/assets/train-icon-white.svg')"
                    />
                </span>
                <span class="station-text">
                    <div>{{ $t("routesInfos.station") }}</div>
                    <div>{{ area[areaName] }}</div>
                </span>
            </div>
            <v-col cols="12" class="routes-container">
                <language-button v-if="showLanguageButton" />
                <div class="routes-title text-center my-2">
                    {{ $t("routesInfos.routes") }}
                </div>
                <v-card
                    v-for="route in routes"
                    :key="route[routeLanguageKey].TRENO"
                    class="my-3"
                    color="#282828"
                >
                    <v-row class="py-0 my-0 px-0 mx-0 first-card-row ">
                        <v-col cols="12" class="py-1 my-0">
                            {{
                                route[routeLanguageKey].RUP +
                                    ": " +
                                    route[routeLanguageKey].TRENO
                            }}
                        </v-col>
                        <v-col cols="12" class="py-1 my-0">
                            <hr class="custom-border mx-1 my-1">
                        </v-col>
                        <v-col cols="12" class="py-1 my-0 second-card-row">
                            {{ route[routeLanguageKey].FROMTO }}
                        </v-col>
                    </v-row>
                    <div class="custom-card-body">
                        <div>
                            <div class="custom-title">
                                {{ $t("routesInfos.gate") }}
                            </div>
                            <div class="custom-box mt-2">
                                {{ route[routeLanguageKey].DR_PLATFORM }}
                            </div>
                        </div>
                        <div>
                            <div class="custom-title">
                                {{ $t("routesInfos.arrival") }}
                            </div>
                            <div class="custom-box mt-2">
                                {{ arrivalData(route[routeLanguageKey]) }}
                            </div>
                        </div>
                        <div>
                            <div class="custom-title">
                                {{ $t("routesInfos.departure") }}
                            </div>
                            <div class="custom-box mt-2">
                                {{ departureData(route[routeLanguageKey]) }}
                            </div>
                        </div>
                        <div>
                            <div class="custom-title">
                                {{ $t("routesInfos.delay") }}
                            </div>
                            <div
                                :class="[
                                    'custom-box mt-2',
                                    route[routeLanguageKey].PREVIOUSDELAY9 > 0
                                        ? 'bordered-box'
                                        : ''
                                ]"
                            >
                                {{
                                    route[routeLanguageKey].PREVIOUSDELAY9 > 0
                                        ? route[routeLanguageKey].PREVIOUSDELAY9 + "΄"
                                        : "-"
                                }}
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import LanguageButton from '@/components/LanguageButton'

    export default {
        components: { LanguageButton },
        props: {
            routes: {
                type: Array,
                default: () => []
            },
            announcements: {
                type: Array,
                default: () => []
            },
            area: {
                type: Object,
                default: () => {}
            }
        },
        computed: {
            language() {
                return this.$store.getters.getLanguage
            },
            areaName() {
                return this.language === 'el' ? 'nameEl' : 'nameEn'
            },
            showLanguageButton() {
                return this.$store.getters.getMode !== 'auto'
            },
            routeLanguageKey() {
                return this.language === 'en' ? 'routesEn' : 'routesEl'
            }
        },
        methods: {
            arrivalData(route) {
                if (this.area.areaCode === 28 || this.area.areaCode === 2) {
                    return route.DR_TANA === null ? '-' : route.DR_TANA.replace('.', ':')
                }
                return route.DR_TANA === null
                    ? route.DR_TAFIX.replace('.', ':')
                    : route.DR_TANA.replace('.', ':')
            },
            departureData(route) {
                return route.DR_TANA === null ? route.DR_TAFIX.replace('.', ':') : '-'
            }
        }
    }
</script>

<style lang="css" scoped>
.bordered-box {
  box-shadow: inset 0 0 0 2px #ee7d11 !important;
}

.logo-container {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-25%, 30%);
}

.station-wrapper {
  margin: 5rem auto;
  display: flex;
  gap: 1rem;
}

.station-text {
  text-align: left;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 30px;
  color: white;
  display: inline-block;
}

.custom-box {
  border: 1px solid #434343;
  height: 45px;
  width: 98px;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-title {
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: #ee7d11;
  text-align: left;
  min-height: 30px;
  display: flex;
  align-items: flex-end;
  max-width: 98px;
}

.custom-card-body {
  padding: 20px;
  background: #282828;
  justify-content: center;
  column-gap: 5px;
  display: flex;
}

.custom-border {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #393939;
}

.second-card-row {
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #ebebeb;
  background: #393939;
}

.first-card-row {
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #929292;
  background: #393939;
}

.custom-background {
  background: #dedede;
}

.routes-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #ebebeb;
}

.background {
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #ee7d11 50%, #dedede 50%);
}

.routes-container {
  background: #000000;
  border-radius: 20px;
  box-shadow: 0 8px 13px 3px rgb(40 40 40 / 20%);
  max-width: 95%;
  padding: 0 8px;
}

.marquee {
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: #727272;
}

@media screen and (max-width: 485px) {
  .custom-card-body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: fit-content;
    padding-top: 10px;
    margin: auto;
  }
}
</style>
